var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row justify-between q-my-sm"},[_c('div',{staticClass:"text-primary q-mr-md",class:_vm.lClass ? _vm.lClass : ''},[_vm._v(_vm._s(_vm.left)+":")]),_c('div',{staticClass:"white-space-preserve",class:_vm.rClass ? _vm.rClass : ''},[_vm._v(_vm._s(_vm.right))])])
}
var staticRenderFns = []

export { render, staticRenderFns }